import { render, staticRenderFns } from "./ConnectionsMarketProducer.vue?vue&type=template&id=be758ca2&"
import script from "./ConnectionsMarketProducer.vue?vue&type=script&lang=js&"
export * from "./ConnectionsMarketProducer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports